import React from 'react';
import { IconProps, IconWrap } from './IconWrap';

export const IconBolt = ({ color = '#3A4B68', width = 8, height = 15, ...props }: IconProps) => {
    return (
        <IconWrap {...props} viewBox="0 0 8 15" width={width} height={height} iconClass="bolt">
            <path
                d="M5 1.5L1 7.5H7L3 13.5"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconWrap>
    );
};
